import { detectPlatform } from './device';

/**
 * Origins and URLs to prewarm. Establishes TCP/TLS connections before the user
 * needs them, reducing latency for manifest, segments, and other critical requests.
 */
const PREWARM_URLS = [
  'https://cloudfront-live.servers8.com',
  'https://alibaba-live.servers8.com',
  'https://akamai-live.servers8.com',
  'https://gcp-live.servers8.com',
  'https://cms-files.thmanyah.com/55555.bin',
  'https://api.thmanyah.com',
  // 'https://thmp90aa.anycast.nagra.com/THMP90AA/wvls/contentlicenseservice/v1/licenses',
];

/**
 * Prewarm origins with HEAD requests. Establishes TCP/TLS connections in the
 * background so subsequent requests are faster. Fire-and-forget; does not block.
 * Call early (e.g. on app mount).
 */
export function prewarmCdnOrigins(): void {
  if (typeof fetch === 'undefined') return;

  const platform = detectPlatform();
  const platformDomain = `https://${platform}.tv.thmanyah.com`;
  const urls = [...PREWARM_URLS, platformDomain];

  urls.forEach(url => {
    const target = url.split('/').length > 3 ? url : url.replace(/\/?$/, '/');
    fetch(target, { method: 'HEAD', cache: 'no-store' }).catch(() => {});
  });
}
